module.exports = __webpack_public_path__ + "src/assets/img/cmdRemoteStart.238fe0a5.svg";